const contentfulHost = `app.contentful.com`;

export default (entry) => {
  const space = process.env.CONTENTFUL_SPACE_ID;
  const environment = process.env.CONTENTFUL_ENVIRONMENT || 'master';

  if (environment === 'master') {
    return `https://${contentfulHost}/spaces/${space}/entries/${entry}`;
  }
  return `https://${contentfulHost}/spaces/${space}/environments/${environment}/entries/${entry}`;
};
